import {Linktype} from "../../types/linktype";


export const igemgames: Linktype[] = [
    {
        title: "University of Guelph iGEM Escape Room Guide",
        link: "https://static.igem.wiki/teams/5611/contribution/biosecurity-breach-igem-escape-room-guide.pdf",
        tag: "other",
        author: "Guelph 2025"
    },
]


/*
 {
        title: "",
        link: "",
        tag: "",
        author: ""
    }
    https://2025.igem.wiki/ualberta/game
    https://2025.igem.wiki/aboa/bacteriumgame
 */
